export default __webpack_public_path__ + "static/media/16.54d9c082.jpg";